import React, { FC, useState } from 'react'
import s from './PriceRange.module.sass'
import { Text } from '@shared/ui/Typography/Text'
import { ErrorBoundary } from '../../../lib/components/ErrorBoundary'
import { Tooltip } from '@shared/ui/Overlays/Tooltip'

interface Props {
  priceRange: number
  colorMode: string
  className?: string
  link?: string
}

const TOOLTIP_PRICES = ['до 1000 ₽', '1000 – 3000 ₽', '3000 – 6000 ₽ ', 'больше 6000 ₽ ']

const PriceRange: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>> = ({
  priceRange,
  colorMode = 'black',
  className = '',
  link,
  ...props
}) => {
  const classes = (...args: Array<string>) =>
    args
      .map((classNameArg: string) => !!classNameArg && s[classNameArg])
      .join(' ')
      .trim()

  const getRootClassName = () => {
    let output = classes('price-range-wrap')
    if (colorMode === 'white') {
      output += ' ' + classes('price-range-wrap--white')
    } else if (colorMode === 'black') {
      output += ' ' + classes('price-range-wrap--black')
    }
    return output
  }

  return (
    <ErrorBoundary>
      <Tooltip>
        <Tooltip.Trigger>
          <span className={`${getRootClassName()} ${link ? s.link : ''} ${className}`} {...props}>
            {Array(4)
              .fill(0)
              .map((el, index) => (
                <Text tag={'span'} sizes={'S'} key={index} data-active={priceRange >= index + 1} uppercase>
                  ₽
                </Text>
              ))}
          </span>
        </Tooltip.Trigger>
        <Tooltip.Content>
          <Text sizes={'S'} className={s['tooltip-text']}>
            {TOOLTIP_PRICES[priceRange - 1]}
          </Text>
        </Tooltip.Content>
      </Tooltip>
    </ErrorBoundary>
  )
}

export default PriceRange
